import { Injectable, effect, inject } from '@angular/core';

import { DomainProfileService } from '../domain-profile-services/domain-profile.service';

@Injectable({
    providedIn: 'root',
})
export class FaviconService {
    private readonly __domainProfileService = inject(DomainProfileService);

    constructor() {
        effect(() => {
            const __svgUrl = this.__domainProfileService.logoIconSvg_url$$();
            const __pngUrl = this.__domainProfileService.logoIconPng_url$$();
            this._apply(__svgUrl, __pngUrl);
        });
    }

    private _apply(svgUrl: string | null, pngUrl: string | null): void {
        const __url = svgUrl ?? pngUrl;
        if (!__url) return;

        // Browsers (vooral Chrome) verversen een <link rel="icon"> notoir onbetrouwbaar als
        // alleen href/type wijzigen op hetzelfde element — het element zelf vervangen (i.p.v.
        // muteren) dwingt een echte herlaad van het tab-icoon af.
        document.head.querySelector<HTMLLinkElement>('link#app-favicon')?.remove();

        const __link = document.createElement('link');
        __link.id = 'app-favicon';
        __link.rel = 'icon';
        __link.type = svgUrl ? 'image/svg+xml' : 'image/png';
        __link.href = __url;
        document.head.appendChild(__link);
    }
}
